/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable jsx-a11y/alt-text */
import React from 'react';

import styles from './NotificationCard.module.css';

interface Props {
  image?: string;
  imageClassName?: string;
  title?: string;
  body?: string;
  isRow?: boolean;
}

export const NotificationCard: React.FC<Props> = props => {
  const { image, imageClassName, title, body, children, isRow = false } = props;
  const isFlex = isRow ? 'flex' : 'flex-col';
  return (
    <div
      className={`${styles.notificationCard} rounded ${isFlex} items-center`}
    >
      <div className="flex-1">
        <div className="flex items-center">
          <img src={image} className={imageClassName} />
          <div className={styles.title}>{title}</div>
        </div>
        <div className={styles.body}>{body}</div>
      </div>
      {children}
    </div>
  );
};
